import React from "react";
import { makeStyles } from "@mui/styles";
import { Favorite } from '@mui/icons-material';
import { useForm, Controller } from "react-hook-form";
import camara from "../../assets/img/camara.png";
import logo from '../../assets/img/loader.png'
import { useLogin } from "../../hooks/useLogin";
import { motion } from 'framer-motion';
import json from '../../../package.json';
import { CustomInputText } from "../CustomInputText";
import { CustomButtonsForm } from "../CustomButtonsForm";

const sloganVariant = {
    hidden: {
        opacity: 0,
        x: 500
    },
    visible: {
        opacity: 1,
        x: 0,
        scale: [ 1, 1.02 ],

        transition: {
            duration: 1, 
            ease: 'easeInOut', 
            type: 'spring',

            scale: {
                delay: 1,
                repeat: Infinity,
                repeatType: 'reverse'
            }
        }
    }
}

export const FormLogin = () => {

    const styles = useStyles();
    const { iniciarSesion } = useLogin();
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    return (
        <>
            <div className={styles.section_left}>
                <div className={styles.container}>
                    <motion.div 
                        className={styles.logo} 
                        initial={{ opacity: 0, x: -600 }} 
                        animate={{ opacity: 1, x: 0 }} 
                        transition={{ duration: 1, ease: 'easeInOut', type: 'spring' }}
                    >
                        <img src={camara} alt="" width={250} />
                    </motion.div>

                    <motion.div 
                        className={styles.forms}
                        initial={{ opacity: 0, x: 300 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, ease: 'easeInOut', type: 'spring' }}
                    >
                        <div style={{ textAlign: "center" }}>
                            <h2 style={{ color: '#00365F' }}>INICIA SESIÓN EN TAIL</h2>
                            <p style={{ fontSize: 14, fontWeight: 'bold', color: '#00365F' }}>Software de gestión integrado</p>
                        </div>

                        <form
                            onSubmit={handleSubmit(iniciarSesion)}
                            style={{
                                marginTop: 40,
                                width: "100%",
                            }}
                        >
                            <Controller
                                name="username"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                    <CustomInputText 
                                        label='Usuario'
                                        placeholder=''
                                        error={ errors.username }
                                        onChange={ onChange }
                                        value={ value }
                                    />
                                )}
                                rules={{
                                    required: "Este campo es obligatorio"
                                }}
                            />

                            <Controller
                                name="contrasena"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                    <CustomInputText 
                                        type='password'
                                        label='Contraseña'
                                        placeholder=''
                                        error={ errors.contrasena }
                                        onChange={ onChange }
                                        value={ value }
                                    />
                                )}
                                rules={{
                                    required: "Este campo es obligatorio"
                                }}
                            />

                            <motion.div transition={{ type: 'spring' }} style={{ marginTop: 36 }}>
                                <CustomButtonsForm 
                                    name='ACCEDER'
                                    type='submit'
                                    fullWidth={ true }
                                    size='medium'
                                />
                            </motion.div>
                        </form>
                    </motion.div>               
                </div>

                <motion.div 
                    className={styles.footer}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: .5, type: 'spring' }}
                >
                    <p style={{ color:'#00365F', fontSize: 16, textAlign: 'center', fontWeight: 800 }}>Hecho con</p>
                    <Favorite sx={{ color: '#e53935', fontSize: 20 }} />
                    <p style={{ color:'#00365F', fontSize: 16, textAlign: 'center', fontWeight: 800 }}>por</p>
                    <img src={ logo } alt='logo' style={{ width: 21 }} />
                    <p style={{ color:'#00365F', fontSize: 16, textAlign: 'center', fontWeight: 800 }}>{`V${ json?.version } - ${ new Date().getFullYear() }` }</p>
                </motion.div>
            </div>

            <div className={styles.section_right}>
                <motion.h2
                    initial='hidden'
                    variants={ sloganVariant }
                    animate='visible'
                >
                    ¡Logrando su crecimiento cumplimos nuestros sueños!
                </motion.h2>
            </div>
        </>
    );
};

const useStyles = makeStyles({
    section_left: {
        height: "100vh",
        width: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: 'relative'
    },

    container: {
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "80%",
        height: 600,
    },

    logo: {
        height: "20%",
        marginTop: 20,
    },

    forms: {
        width: 300,
        height: "60%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",

        "& h1": {
            color: "#004584",
            letterSpacing: 1,
        },

        "& p": {
            fontSize: 13,
            fontWeight: "400",
            padding: 4,
        }
    },

    footer: {
        position: "absolute",
        bottom: 0,
        marginBottom: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4
    },

    section_right: {
        backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='881' height='881' preserveAspectRatio='none' viewBox='0 0 881 881'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1591%26quot%3b)' fill='none'%3e%3crect width='881' height='881' x='0' y='0' fill='rgba(0%2c 69%2c 132%2c 1)'%3e%3c/rect%3e%3cpath d='M365.19 699.3 a206.52 206.52 0 1 0 413.04 0 a206.52 206.52 0 1 0 -413.04 0z' fill='rgba(28%2c 83%2c 142%2c 0.41)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M584.61 676.26 a267.06 267.06 0 1 0 534.12 0 a267.06 267.06 0 1 0 -534.12 0z' fill='rgba(28%2c 83%2c 142%2c 0.41)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M619.94 276.99 a177.39 177.39 0 1 0 354.78 0 a177.39 177.39 0 1 0 -354.78 0z' fill='rgba(28%2c 83%2c 142%2c 0.41)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M-29.47 56.58 a198.35 198.35 0 1 0 396.7 0 a198.35 198.35 0 1 0 -396.7 0z' fill='rgba(28%2c 83%2c 142%2c 0.41)' class='triangle-float2'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1591'%3e%3crect width='881' height='881' fill='white'%3e%3c/rect%3e%3c/mask%3e%3cstyle%3e %40keyframes float1 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(-10px%2c 0)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float1 %7b animation: float1 5s infinite%3b %7d %40keyframes float2 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(-5px%2c -5px)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float2 %7b animation: float2 4s infinite%3b %7d %40keyframes float3 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(0%2c -10px)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float3 %7b animation: float3 6s infinite%3b %7d %3c/style%3e%3c/defs%3e%3c/svg%3e")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        width: "50%",
        height: "100vh",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        '& h2': {
            color: '#fff',
            fontSize: '1.5rem'
        }
    },

    loginButton: {
        background: '#00365F !important',
        color: '#fff !important',
        fontWeight: 'bold',
        '&:hover': {
            color: '#00365F !important',
            background: '#fff !important',
            borderColor: '#00365F !important'
        }
    }
});